import styled from 'styled-components';

const Container = styled.div`
  background-color: black;
  display: flex;
  flex-direction: column;

  justify-content: center;

  width: 100%;
  margin: 0 auto;
`;

export { Container };
